type DownloadWindow = {
  location: { href: string };
  close: () => void;
};

export const navigateDownloadWindow = (
  downloadWindow: DownloadWindow | null,
  url: string | undefined,
): void => {
  if (url && downloadWindow) {
    downloadWindow.location.href = url;
  } else {
    downloadWindow?.close();
  }
};
